"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerCreditDataToJSON = exports.CustomerCreditDataFromJSONTyped = exports.CustomerCreditDataFromJSON = void 0;
var _1 = require("./");
function CustomerCreditDataFromJSON(json) {
    return CustomerCreditDataFromJSONTyped(json, false);
}
exports.CustomerCreditDataFromJSON = CustomerCreditDataFromJSON;
function CustomerCreditDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'paymentData': (0, _1.CustomerCreditDataPaymentDataFromJSON)(json['paymentData']),
        'delayedPayment': (0, _1.CustomerCreditDataDelayedPaymentFromJSON)(json['delayedPayment']),
        'paymentInsurance': (0, _1.CustomerCreditDataPaymentInsuranceFromJSON)(json['paymentInsurance']),
    };
}
exports.CustomerCreditDataFromJSONTyped = CustomerCreditDataFromJSONTyped;
function CustomerCreditDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'paymentData': (0, _1.CustomerCreditDataPaymentDataToJSON)(value.paymentData),
        'delayedPayment': (0, _1.CustomerCreditDataDelayedPaymentToJSON)(value.delayedPayment),
        'paymentInsurance': (0, _1.CustomerCreditDataPaymentInsuranceToJSON)(value.paymentInsurance),
    };
}
exports.CustomerCreditDataToJSON = CustomerCreditDataToJSON;
//# sourceMappingURL=CustomerCreditData.js.map